export default "__VITE_ASSET__egmyC1cs__"